import { makeStyles } from 'tss-react/mui';

export default makeStyles()(theme => ({
    paper: {
        display: 'flex',
        justifyContent: 'center',
        padding: theme.spacing(2)
    },
    buttons: {
        position: "fixed",
        bottom: theme.spacing(2),
        right: theme.spacing(2)
    },
    fab: {
        margin: `0px ${theme.spacing(1)}`
    },
    rootFab: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'center',
        }
    }
}));

